import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_NO.json';
import exercises from './PILATES_EXERCISES_NO.json';
import recipes from './PILATES_RECIPES_NO.json';

export const PILATES_DATA_NO: ServiceData = {
  articles,
  exercises,
  recipes,
};
